import { module } from 'modujs';
import Splide from '@splidejs/splide'
import { leadingZero } from '../utils/maths'

export default class SliderFancy extends module {

    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el
        this.$slider = this.$('slider')[0]
        this.$activeIndex = this.$('activeIndex')[0]
    }

    init() {
        this.splide = new Splide(this.$el, {
            autoWidth: true,
            drag: false,
            pagination: false,
            speed: 0,
            type: 'loop',
        })

        this.splide.mount()

        this.splide.on('move', e => {
            const index = e + 1
            this.$activeIndex.innerHTML = leadingZero(index, 2)
        })
    }

    destroy() {
        super.destroy()

        this.splide?.destroy()
    }
}
